import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export function useReturnOTPToDraft(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, number>({
        mutationKey: [QueryKeys.otp, 'returnToDraft'],
        mutationFn: async (id: number) => {
            return await OTPApi.returnOTPToDraft(id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId) 
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });
            
            notifications.show({
                title: t('otp.notifications.returnToDraftSuccess.title'),
                message: t('otp.notifications.returnToDraftSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.returnToDraftError.title'),
                message: error?.message || t('otp.notifications.returnToDraftError.message'),
                color: 'red',
            });
        },
    });
}
